import React from 'react';
import { datadogRum } from '@datadog/browser-rum';

class DatadogErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to Datadog RUM if available
    if (datadogRum && typeof datadogRum.addError === 'function') {
      if (!(error instanceof Error)) {
        error = new Error(error);
      }
      datadogRum.addError(error, {
        source: 'react',
        componentStack: errorInfo.componentStack,
        errorInfo,
      });
    }
  }

  // Permite reportar errores manuales de lógica/API
  static reportError(error, info = {}) {
    if (datadogRum && typeof datadogRum.addError === 'function') {
      if (!(error instanceof Error)) {
        error = new Error(error);
      }
      datadogRum.addError(error, {
        source: 'manual',
        ...info,
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // Re-throw the error to let React handle it normally
      throw this.state.error;
    }

    return this.props.children;
  }
}

export default DatadogErrorBoundary;
